import React, { useState, useEffect } from 'react';
import { verifyIfscAction } from '../../../redux/services/index';
import { connect } from 'react-redux';
import { RootState } from '../../../redux/rootReducers';
import { ServicesInput } from '../../../components/Services';
import { resetIfscData, resetServicesError, resetServicesSucces } from '../../../redux/services';
import { IfscType } from '../../../redux/services/serviceTypes';
import { getIfscDataType } from '../../../commonTypes/serviceTypes';
import { Loader, CommonHeader } from '../../../components/commons';
import { useMenuCheck } from '../../../customHooks/useMenuCheck';
import { GetPathBeforeClientCode } from '../../../components/commons/UserManagement';

type AppProps = {
    dispatchGetIfscDataAction: (data: getIfscDataType) => void;
    dispatchResetIfscData: () => void;
    dispatchResetServicesError: () => void;
    dispatchResetServicesSuccess: () => void;
    fetching: boolean;
    ifscData: IfscType | null;
    error: string | null;
    token: string | null;
    history:any;
}

const Ifsc = ({
    dispatchGetIfscDataAction,
    dispatchResetIfscData,
    dispatchResetServicesError,
    dispatchResetServicesSuccess,
    ifscData,
    fetching,
    error,
    token,
    history
}: AppProps) => {
    const [ifscNumber, setIfscNumber] = useState<string>('');
    const [isIfscNumberUrlPresent,setIsIfscNumberUrlPresent]=useMenuCheck()
    const url=history?.location?.pathname
    useEffect(() => {
        setIsIfscNumberUrlPresent(GetPathBeforeClientCode(url),"url")
        dispatchResetIfscData();
        dispatchResetServicesError();
        dispatchResetServicesSuccess();
    }, []);

    useEffect(()=>{
     if(isIfscNumberUrlPresent===false){
        history.push("/access-denied")
     }
    },[isIfscNumberUrlPresent])

    const handleIfsc = (event: any) => {
        setIfscNumber(event.target.value);
    };

    const getIfscData = () => {
        let data = {
            ifscNumber,
            token
        }
        dispatchGetIfscDataAction(data);
    };

    return (
        <div className="ifsc-wrap">
            <CommonHeader title="Search Bank IFSC Code" />
            <div className="row">
                <div className="col-4  login-leftx " style={{ borderRadius: "8px" }}>
                    <ServicesInput
                        handleChange={handleIfsc}
                        placeholder="IFSC Code"
                        serviceType={ifscNumber}
                        autoFocus
                    />
                    <button
                        className="btn btn-primary w-100 mt-2"
                        onClick={getIfscData}
                        disabled={ifscNumber?.length !== 11}
                    >
                        Submit
                    </button>
                </div>

                {ifscData && ifscData.ifsc
                    ? <div className="col-8">
                        <table className="table table-bordered table-border-radius" >
                            <tbody>
                                <tr>
                                    <th style={{ width: '30%' }}>Centre Name</th> <td className="centre">{ifscData.centre}</td>
                                </tr>

                                <tr>
                                    <th>Branch Name</th> <td className="branch">{ifscData.branch}</td>
                                </tr>

                                <tr>
                                    <th>MICR Code</th> <td className="micr">{ifscData.micr}</td>
                                </tr>

                                <tr>
                                    <th>UPI</th> <td className="upi">{ifscData.upi}</td>
                                </tr>

                                <tr>
                                    <th>RTGS</th> <td className="rtgs">{ifscData.rtgs}</td>
                                </tr>

                                <tr>
                                    <th>IMPS</th> <td className="imps">{ifscData.imps}</td>
                                </tr>

                                <tr>
                                    <th>NEFT</th> <td className="neft">{ifscData.neft}</td>
                                </tr>

                                <tr>
                                    <th>Swift Code</th> <td className="swift">{ifscData.swift}</td>
                                </tr>

                                <tr>
                                    <th>IFSC Code</th> <td className="ifsc">{ifscData.ifsc}</td>
                                </tr>

                                <tr>
                                    <th>Bank</th> <td className="bank">{ifscData.bank}</td>
                                </tr>

                                <tr>
                                    <th>District</th> <td className="district">{ifscData.district}</td>
                                </tr>

                                <tr>
                                    <th>State</th> <td className="state">{ifscData.state}</td>
                                </tr>

                                <tr>
                                    <th>Contact</th> <td className="contact">{ifscData.contact}</td>
                                </tr>

                                <tr>
                                    <th>Address</th> <td className="address">{ifscData.address}</td>
                                </tr>


                            </tbody></table>
                    </div>
                    :
                    error
                        ? <div className="col-8">
                            <div className="card p-5 w-100">
                                <h3 className="error">
                                    {!!error ? error : 'No result Found!'}
                                </h3>

                            </div>
                        </div> : null

                }
            </div>
            {fetching && <Loader />}
        </div>

    )
};

const mapStateToProps = (state: RootState) => ({
    ifscData: state.services.ifscDetails,
    fetching: state.services.fetching,
    error: state.services.error,
    token: state.auth.token
})

const mapDispatchToProps = (dispatch: any) => ({
    dispatchGetIfscDataAction: (data: getIfscDataType) => dispatch(verifyIfscAction(data)),
    dispatchResetIfscData: () => dispatch(resetIfscData()),
    dispatchResetServicesError: () => dispatch(resetServicesError()),
    dispatchResetServicesSuccess: () => dispatch(resetServicesSucces())
})

export default connect(mapStateToProps, mapDispatchToProps)(Ifsc);